class Timer {
    constructor(options) {
        options = Object.assign({
            updateInterval: 1000,
            getTimestamp: function() {
                return Date.now().getTime();
            }
        }, options);
        this.startTime = 0;
        this.minTime = 0;
        this.elapsedTime = 0;
        this.timeoutId = null;
        this.updateInterval = options.updateInterval;
        this.onUpdate = options.update;
        this.onCancel = options.cancel;
        this.onSuccess = options.success;
        this.onFinish = options.finish;
        this.getTimestamp = options.getTimestamp;
        this.stopped = true;
    }

    start(minTime) {
        this.cancel();
        this.minTime = minTime || 0;
        this.startTime = this.getTimestamp();
        this.elapsedTime = 0;
        this.stopped = false;
        this.update();
    }

    update() {
        this.elapsedTime = this.getTimestamp() - this.startTime;
        if (this.onUpdate && this.onUpdate() === false) {
            this.cancel();
            return;
        }

        if (this.stopped) {
            return;
        }
        if (this.elapsedTime < this.minTime) {
            this.timeoutId = setTimeout(() => {
                this.update();
            }, this.updateInterval);
        } else {
            this.stopped = true;
            if (this.onSuccess) {
                this.onSuccess();
            }
            if (this.onFinish) {
                this.onFinish();
            }
        }
    }

    cancel() {
        if (this.timeoutId) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
        if (!this.stopped) {
            this.stopped = true;
            if (this.onCancel) {
                this.onCancel();
            }
            if (this.onFinish) {
                this.onFinish();
            }
        }
    }
}

export default Timer;
